import { memo, useEffect, useRef, useState } from "react";
import useDrop from "../hooks/useDrop.jsx";
import icon_upload from "../../../assets/webp/upload.webp";

// eslint-disable-next-line react/display-name
export const Dropzone = memo(() => {
  const iconRef = useRef(null);
  const [isOver, setIsOver] = useState(false);  //Manejo del stado para animar el icono
  const { getRootProps, getInputProps, error } = useDrop();           //Referencia persistente

  //? Funciones activar/desactivar animacion
  const onMouseOver = () => setIsOver(true);
  const onMouseLeave = () => setIsOver(false);
  
  
  useEffect(() => {
    const {ref} = getRootProps();

    if(!ref.current) return;
    const currentDropzone = ref.current;

    currentDropzone.addEventListener('dragover', onMouseOver);
    currentDropzone.addEventListener('dragleave', onMouseLeave);

    return () => {
      currentDropzone.removeEventListener('dragover', onMouseOver);
      currentDropzone.removeEventListener('dragleave', onMouseLeave);
    }
  }, [getRootProps])
  
  
  if (iconRef.current) console.log(iconRef.current.style);
  
  return (
    <>
      <div 
        className="dropzone"
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        {...getRootProps()}>

          <input {...getInputProps()} />

          <img 
              ref={iconRef}
              className={`${isOver ? 'md-icon--zoom' : 'md-icon'} dropzone__content--icon`}
              src={icon_upload} 
              alt="upload"/>

          <div className="dropzone__content--text sm-text grey-text">
            <p style={{marginBottom: '8px'}}><strong className="md-text" style={{marginBottom: '8px'}}>Agrega un documento</strong></p>
            <p>
              Arrastra y suelta tu PDF, o
              <br /> 
              <span className="red-text">haz clic</span> para seleccionar.
            </p>
          </div>

      </div>
      <p className="dropzone__error sm-text mh-1">
        {error}
      </p>
    </>
  );
});
